import * as React from 'react';
import { Box } from '../Box';
import * as styles from './Center.module.css';

export const Center = React.forwardRef(function Center(
  {
    children,
    className = '',
    element = 'div',
    height = 'auto',
    padding = 'none',
    width = 'auto',
    ...rest
  },
  ref,
) {
  const combinedClasses = [
    styles.center,
    className
  ].filter(Boolean).join(' ');

  return (
    <Box
      className={combinedClasses}
      display="flex"
      element={element}
      height={height}
      padding={padding}
      ref={ref}
      width={width}
      {...rest}
    >
      {children}
    </Box>
  );
});
